/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerEmail
 */
export interface PartnerEmail {
    /**
     * 
     * @type {boolean}
     * @memberof PartnerEmail
     */
    primary?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PartnerEmail
     */
    eMail?: string;
}

/**
 * Check if a given object implements the PartnerEmail interface.
 */
export function instanceOfPartnerEmail(value: object): value is PartnerEmail {
    return true;
}

export function PartnerEmailFromJSON(json: any): PartnerEmail {
    return PartnerEmailFromJSONTyped(json, false);
}

export function PartnerEmailFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerEmail {
    if (json == null) {
        return json;
    }
    return {
        
        'primary': json['primary'] == null ? undefined : json['primary'],
        'eMail': json['eMail'] == null ? undefined : json['eMail'],
    };
}

export function PartnerEmailToJSON(json: any): PartnerEmail {
    return PartnerEmailToJSONTyped(json, false);
}

export function PartnerEmailToJSONTyped(value?: PartnerEmail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'primary': value['primary'],
        'eMail': value['eMail'],
    };
}

